import React, { Component } from 'react'
import Recaptcha from 'react-recaptcha'
import { Redirect } from 'react-router-dom'
import ErrorMessage from '../Messages/errorMessage.jsx';
import SuccessMessage from '../Messages/successMessage.jsx';
import InputInitialForm from '../Forms/inputOfInitialForm.jsx';
import CommonFetch from '../../requests/commonFetch'

export default class Registration extends Component {
    constructor(props) {
        super(props)

        this.state = {
            errorMessage: '',
            successMessage: 'An letter has been sent to the specified email address',
        }

        this.arrayOfErrorMessage = {
            "already_exist": "Already exist",
            "email_not_valid": "Email not valid",
            "not_registered ": "Not registered",
            "send_mail_problem": "Send mail problem",
            "wrong_captcha": "Wrong captcha",
        }

        this.translation = JSON.parse(localStorage.translation)[localStorage.language];

        this.errorMessage = React.createRef();
        this.successMessage = React.createRef();
    }

    sendFromRecover = event => {
        event.preventDefault();
        let form = event.target,
            inputs = form.querySelectorAll('input[type=text], input[type=password]'),
            valid = true;

        inputs.forEach(item => {
            if (!item.value) {
                valid = false;
            }
            this.checkValidInput(item);
        })

        if (valid) {
            CommonFetch({
                path: 'ui/auth/post_recover',
                method: 'POST',
                data: new FormData(form),
            }).then(data => {
                this.recaptcha.reset()

                if (data.success) {
                    this.successMessage.current.showMessage()
                } else if (data.error === 'already_logged_in') {
                    this.props.switchSignIn()
                } else {
                    this.setState({
                        errorMessage: this.arrayOfErrorMessage[data.error],
                    })
                    this.errorMessage.current.showMessage()
                    form.querySelector('input[name=email]').value = ''
                }
            })
        }

    }

    checkValidInput = event => {
        let input = event.tagName === 'INPUT' ? event : event.target;
        input.setCustomValidity('');
        if (!input.validity.valid) {
            input.setCustomValidity(this.translation['fill this field']);
        }
    }

    inputFocus = event => {
        let elem = event.target,
            input = elem.tagName === 'INPUT' ?
                elem : elem.parentNode.querySelector('input');

        input.removeAttribute('readonly');
        input.classList.add('active');
        input.focus();
    }

    removeAttrReadOnly = event => {
        let inputs = event.target.parentNode.querySelectorAll('input');
        inputs.forEach(item => {
            item.removeAttribute('readonly');
        })
    }

    render() {
        const { from } = this.props.location.state || {
            from: { pathname: '/' },
        }

        if (this.props.signIn) {
            return <Redirect to={from} />
        }

        return (
            <div className="recContainer">
                <p className="recContainer_header">{this.translation['Password recovery']}</p>
                <hr />
                <div className="recContainer_main">
                    <form
                        className="recContainer_main_form"
                        onInvalid={this.checkValidInput}
                        onSubmit={this.sendFromRecover}
                    >
                        <div className="recContainer_main_form_email">
                            <InputInitialForm
                                type="text"
                                name="email"
                                title={this.translation['fill this field']}
                            />
                            <span onClick={this.inputFocus}>Email</span>
                        </div>
                        {this.props.captchaKey ? (
                            <Recaptcha
                                sitekey={`${this.props.captchaKey}`}
                                ref={e => (this.recaptcha = e)}
                                render="explicit"
                                theme="dark"
                                size="normal"
                                badge="inline"
                                onloadCallback={this.recaptchaLoaded()}
                                hl={localStorage.language}
                            />
                        ) : null}
                        <input
                            className="recContainer_main_form_recover"
                            type="submit"
                            value={this.translation['Restore']}
                            onClick={this.removeAttrReadOnly}
                        />
                    </form>
                </div>
                <ErrorMessage
                    ref={this.errorMessage}
                    errorMessage={this.state.errorMessage}
                />
                <SuccessMessage
                    ref={this.successMessage}
                    successMessage={this.state.successMessage}
                />
            </div>
        )
    }

    recaptchaLoaded = () => {}
}
